var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { safeBtoa } from 'pxc-editor-core/helpers/common';
import { INTERACTION_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { parseInitProjectData } from 'pxc-editor-web/environment_modules/xcore/helpers/parser';
import { getUnsavedProjectFromLocalStorage, getWizardData } from '@/helpers';
import { WEB_COMPONENT_ACTIONS, USER_SIZE_UNIT_INCH, CABLE_FLAG, } from '@/constants';
import { uploadProject } from '@/actions/project';
import { setUserSizeUnit, setShowLoader, setModeActionThunk } from '@/actions';
import WebComponent from '@/endpoints/webComponent';
export var updateWebcomponentConfig = function (payload) {
    return {
        type: WEB_COMPONENT_ACTIONS.SET_DATA,
        payload: payload,
    };
};
export var getDataFromAttributesThunk = function (payload) { return function (dispatch) {
    var locale = payload.locale;
    if (locale === 'en-US') {
        dispatch(setUserSizeUnit(USER_SIZE_UNIT_INCH));
    }
    dispatch(updateWebcomponentConfig(payload));
}; };
var uploadProjectFromStorage = function (data) { return function (dispatch) {
    dispatch(uploadProject({ projectData: parseInitProjectData(data) }));
    dispatch(setShowLoader(false));
}; };
export var getMaterialViaLinkThunk = function (productId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var latestReleasePackage, releaseId, response, parsedProjectData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 4, 5]);
                dispatch(setShowLoader(true));
                return [4 /*yield*/, WebComponent.getLatestReleasePackage()];
            case 1:
                latestReleasePackage = _a.sent();
                releaseId = latestReleasePackage === null || latestReleasePackage === void 0 ? void 0 : latestReleasePackage.id;
                return [4 /*yield*/, WebComponent.getMaterialByArticleNumber(releaseId, productId)];
            case 2:
                response = _a.sent();
                if (response === null || response === void 0 ? void 0 : response.material) {
                    parsedProjectData = parseInitProjectData({
                        material: {
                            name: response.material.general.fullname,
                            contents: JSON.stringify(response),
                            is_base64: false,
                        },
                        material_selected_article_number: productId,
                    });
                    dispatch(uploadProject({ projectData: parsedProjectData }));
                }
                else {
                    dispatch(uploadProjectFromStorageThunk());
                }
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                console.error('[getMaterialViaLinkThunk]:', error_1);
                return [3 /*break*/, 5];
            case 4:
                dispatch(setShowLoader(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var uploadMaterialThunk = function () { return function (dispatch, getState) {
    var config = getState().cmmeReducer.config;
    var unsavedProject = getUnsavedProjectFromLocalStorage();
    var productId = config.productId;
    if (productId) {
        if ((unsavedProject === null || unsavedProject === void 0 ? void 0 : unsavedProject.material_selected_article_number) === productId) {
            dispatch(uploadProjectFromStorageThunk());
        }
        else {
            dispatch(getMaterialViaLinkThunk(productId));
        }
    }
    else {
        dispatch(uploadProjectFromStorageThunk());
    }
}; };
var uploadProjectFromStorageThunk = function () { return function (dispatch) {
    var unsavedProject = getUnsavedProjectFromLocalStorage();
    if (unsavedProject) {
        dispatch(setShowLoader(true));
        setTimeout(function () {
            dispatch(uploadProjectFromStorage(unsavedProject));
        }, 100);
    }
}; };
export var getMaterialByArticleNumberThunk = function (productId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var latestReleasePackage, releaseId, response, wizard, parsedProjData, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, 4, 5]);
                dispatch(setShowLoader(true));
                return [4 /*yield*/, WebComponent.getLatestReleasePackage()];
            case 1:
                latestReleasePackage = _a.sent();
                releaseId = latestReleasePackage === null || latestReleasePackage === void 0 ? void 0 : latestReleasePackage.id;
                return [4 /*yield*/, WebComponent.getMaterialByArticleNumber(releaseId, productId)];
            case 2:
                response = _a.sent();
                if (response === null || response === void 0 ? void 0 : response.material) {
                    wizard = safeBtoa(JSON.stringify({
                        application_type: CABLE_FLAG,
                        data: getWizardData({}),
                    }));
                    parsedProjData = parseInitProjectData({
                        material: {
                            name: response.material.general.fullname,
                            contents: JSON.stringify(response),
                            is_base64: false,
                        },
                        wizard: wizard,
                    });
                    dispatch(uploadProject({
                        projectData: parsedProjData,
                        beforeFinishActionsClb: function () {
                            return dispatch(setModeActionThunk(INTERACTION_MODE.WIZARD));
                        },
                    }));
                }
                return [3 /*break*/, 5];
            case 3:
                error_2 = _a.sent();
                console.error('[getMaterialByArticleNumberThunk]:', error_2);
                return [3 /*break*/, 5];
            case 4:
                dispatch(setShowLoader(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var setLoginRequiredModalOpen = function (value) {
    return {
        type: WEB_COMPONENT_ACTIONS.LOGIN_REQUIRED_MODAL,
        payload: value,
    };
};
export var setSaveProjectModalOpen = function (value) {
    return {
        type: WEB_COMPONENT_ACTIONS.SAVE_PROJECT_MODAL,
        payload: value,
    };
};
export var setAddToCartStatus = function (value) {
    return {
        type: WEB_COMPONENT_ACTIONS.ADD_TO_CART_STATUS,
        payload: value,
    };
};
export var setShortcutModalOpen = function (value) {
    return {
        type: WEB_COMPONENT_ACTIONS.SHORTCUT_MODAL,
        payload: value,
    };
};
export default {
    updateWebcomponentConfig: updateWebcomponentConfig,
    setLoginRequiredModalOpen: setLoginRequiredModalOpen,
    setSaveProjectModalOpen: setSaveProjectModalOpen,
    setAddToCartStatus: setAddToCartStatus,
    setShortcutModalOpen: setShortcutModalOpen,
};
